import { type ReactNode, useMemo } from 'react';

import { useParams } from '@remix-run/react';
import type { TPostElement } from '@shared/dream-components';

import Post from './Post';

interface Props {
  node: TPostElement;
  children: ReactNode | ReactNode[];
}

const PostContainer = ({ node, children }: Props) => {
  const { id, postGroupType } = node.attrs;
  const isTagPage = postGroupType === 'tag_page';
  const isRecommendationsBlock = postGroupType === 'recommendations';
  const { tag, slug } = useParams();

  const componentKey = useMemo(() => {
    if (isRecommendationsBlock) {
      return `${id}-recommendations-${slug}`;
    }

    if (isTagPage && tag) {
      return `${id}-tag-${tag}`;
    }

    return id;
  }, [id, isRecommendationsBlock, isTagPage, slug, tag]);

  return (
    <Post key={componentKey} node={node}>
      {children}
    </Post>
  );
};

export default PostContainer;
